import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { MapPin, Phone, Mail, User, Building } from 'lucide-react';

const Impressum = () => {
  const contactInfo = [
    {
      icon: User,
      label: "Inhaberin",
      value: "Sabrina Kure"
    },
    {
      icon: Building,
      label: "Unternehmen",
      value: "Sabrina Kure Energetik_und mehr"
    },
    {
      icon: MapPin,
      label: "Adresse",
      value: "Mitteregg 24, 8524 Deutschlandsberg, Österreich"
    },
    {
      icon: Phone,
      label: "Telefon",
      value: "+43 664 9703314",
      link: "tel:+436649703314"
    },
    {
      icon: Mail,
      label: "E-Mail",
      value: "sabrina.kure@yahoo.com",
      link: "mailto:sabrina.kure@yahoo.com"
    }
  ];

  return (
    <>
      <PageHero 
        title="Impressum" 
        description="Rechtliche Informationen und Kontaktdaten"
        image="https://images.unsplash.com/photo-1564013799919-ab600027ffc6"
      />
      
      <section className="py-20" style={{ backgroundColor: '#F6E9B2' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Main Contact Information */}
            <GlassCard className="p-8 mb-8">
              <h2 className="text-2xl font-bold text-primary-deep mb-8 text-center">
                Kontaktinformationen
              </h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-primary-light rounded-full flex items-center justify-center shrink-0">
                      <info.icon className="h-6 w-6 text-primary-deep" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">{info.label}</h3>
                      {info.link ? (
                        <a 
                          href={info.link}
                          className="text-primary-main hover:text-primary-deep transition-colors font-medium"
                        >
                          {info.value}
                        </a>
                      ) : (
                        <p className="text-gray-700">{info.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </GlassCard>

            {/* Legal Information */}
            <div className="grid md:grid-cols-2 gap-6">
              <GlassCard className="p-6">
                <h3 className="text-xl font-bold text-primary-deep mb-4">
                  Berufsgruppe
                </h3>
                <p className="text-gray-700 mb-4">
                  Humanenergetiker nach dem österreichischen Gewerberecht
                </p>
                <p className="text-sm text-gray-600">
                  Die Tätigkeit der Energiearbeit ist eine Dienstleistung zur Aktivierung 
                  der Selbstheilungskräfte und dient der Gesundheitsvorsorge.
                </p>
              </GlassCard>

              <GlassCard className="p-6">
                <h3 className="text-xl font-bold text-primary-deep mb-4">
                  Rechtlicher Hinweis
                </h3>
                <p className="text-gray-700 mb-4">
                  Energetische Behandlungen ersetzen nicht den Besuch beim Arzt.
                </p>
                <p className="text-sm text-gray-600">
                  Bei gesundheitlichen Beschwerden wenden Sie sich bitte an einen 
                  Arzt oder Heilpraktiker Ihres Vertrauens.
                </p>
              </GlassCard>
            </div>

            {/* Disclaimer */}
            <GlassCard className="p-6 mt-6 bg-blue-50 border-blue-200">
              <h3 className="text-lg font-semibold text-blue-800 mb-3">
                Haftungsausschluss
              </h3>
              <p className="text-blue-700 text-sm">
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die 
                Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich 
                deren Betreiber verantwortlich. Die Inhalte dieser Website werden mit größter 
                Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der 
                Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default Impressum;